
import Rellax from 'rellax'

const defaultParams = {
  speed : 6
}

export default class Parallax {

  constructor(selector, params) {
    this.target = document.querySelector(selector);
    this.params = $.extend({}, defaultParams, params);

    if (this.target !== null) {
      this.init();
    }
  }

  init() {
    const rellax = new Rellax(this.target, this.params);
  }
}

